import HitSender from './modules/HitSender';
import { hasMessage, storeMessage } from './modules/storage';
export const startErrorHandling = (config) => {
    const { endpoint, baseUrl, scriptName } = config;
    const initMessage = `${scriptName}-init`;
    if (hasMessage(initMessage)) {
        // Prevent multiple listeners in SPA
        return;
    }
    storeMessage(initMessage);
    const errorHandler = (errorEvent) => {
        const { error } = errorEvent;
        if (!error || !error.stack || !error.message) {
            return;
        }
        const { message, stack } = error;
        // every script can log any error only once
        const storageMessage = `${scriptName}-${message}`;
        if (hasMessage(storageMessage)) {
            // This error has already been sent
            return;
        }
        if (stack.indexOf(`/${scriptName}`) > -1) {
            new HitSender(endpoint, baseUrl)
                .appendValue('msg', message)
                .appendValue('script', scriptName)
                .appendValue('href', window.location.href)
                .appendValue('referrer', document.referrer)
                .appendValue('stack', stack)
                .send();
            storeMessage(storageMessage);
        }
    };
    window.addEventListener('error', errorHandler);
};
